exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.fade-enter-active[data-v-207dea5f],\n.fade-leave-active[data-v-207dea5f] {\n  transition: opacity 1s;\n}\n.alert-text-success-inline[data-v-207dea5f] {\n  position: fixed;\n  top: 61px;\n  text-align: center;\n  width: 100%;\n  z-index: 1;\n}\n", ""]);

// exports
